export default {
  accountManagement: 'ACCOUNT_MANAGEMENT',
  dataManagement: 'DATA_MANAGEMENT',
};
